// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import ChevronRight from "@stoneage/XDL/Icons/ChevronRight";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";

export const viewAllLinkStyle: LinkPresentationProps = {
    typographyProps: {
        ...fontConfig.regularSingleLine,
        weight: fontConfig.weight.medium,
    },
    icon: {
        iconProps: {
            src: ChevronRight,
            size: 10,
        },
        position: "right",
    },
    css: css`
        align-self: baseline;
    `,
};
